/**
 * Telefoonweergave (19-10-2026, Jordy): onder 900px krijgt het dashboard een
 * eigen, mobiele indeling. Daarboven verandert er NIETS: alles wat alleen op
 * de telefoon bestaat, hangt aan deze grens (JS) of staat in mobiel.css
 * binnen dezelfde media query (CSS).
 *
 * De grens is 899.98px: een venster van precies 900px telt nog als desktop.
 */
import { useEffect, useState } from 'react'

export const MOBIEL_QUERY = '(max-width: 899.98px)'

/** Nu op een telefoonbreedte? Synchroon, dus te gebruiken vóór de eerste render. */
export function isMobiel(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    && window.matchMedia(MOBIEL_QUERY).matches
}

/** Volgt de telefoongrens; wisselt mee als het venster draait of smaller wordt. */
export function useMobiel(): boolean {
  const [mobiel, zet] = useState(isMobiel)
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(MOBIEL_QUERY)
    const f = () => zet(mq.matches)
    f()
    mq.addEventListener('change', f)
    return () => mq.removeEventListener('change', f)
  }, [])
  return mobiel
}
